// extracted by mini-css-extract-plugin
export default {"file":"style_file__o5cRs","uploadfile":"style_uploadfile__w1Nsr","btnUploadFile":"style_btnUploadFile__uqqZc"};